export const SiteStatusList = [
  {
    label: "Active",
    value: "active",
  },
  {
    label: "Coming Soon",
    value: "comingSoon",
  },
  {
    label: "Maintenance",
    value: "maintenance",
  },
];
